// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --sidebar-width: 280px;
  --row-height: 80px;
  --card-min-width: 260px;
  --transition-speed: 0.2s;
}

ion-content {
  --background: var(--bg-color);
  --padding-top: 0;
  overflow-x: hidden;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

ion-toolbar {
  --border-style: none;
  --border-width: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  z-index: 20;
}

ion-title p {
  font-family: var(--font);
  font-weight: 600;
  font-size: 1.1rem;
  margin: 0;
}

/* ===========================================================
   SEARCH TOOLBAR
   =========================================================== */
.search-toolbar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  padding: 12px 28px;
  position: sticky;
  top: 0;
  z-index: 15;
}

.search-toolbar-row {
  display: flex;
  align-items: center;
  gap: 16px;
}

.search-wrapper {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.04);
  border-radius: 10px;
  padding: 0 16px;
  height: 44px;
  transition: box-shadow var(--transition-speed), background var(--transition-speed);
}
.search-wrapper:focus-within {
  background: #fff;
  box-shadow: 0 0 0 2px var(--active-color, #6c63ff);
}

.search-icon {
  font-size: 20px;
  opacity: 0.5;
  margin-right: 12px;
  flex-shrink: 0;
}

.search-input {
  border: none;
  background: transparent;
  outline: none;
  width: 100%;
  min-width: 0;
  height: 100%;
  font-size: 0.95rem;
  font-family: var(--font);
  color: inherit;
}
.search-input:focus {
  outline: none;
  box-shadow: none;
}
.search-input::placeholder {
  color: var(--placeholder-color);
  opacity: 0.6;
}

.toolbar-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.view-toggle {
  display: flex;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  padding: 3px;
  gap: 2px;
}

.toggle-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 34px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.45);
  transition: all var(--transition-speed);
  font-size: 20px;
}
.toggle-btn:hover {
  color: rgba(0, 0, 0, 0.7);
  background: rgba(0, 0, 0, 0.04);
}
.toggle-btn.active {
  background: #fff;
  color: var(--active-color, #6c63ff);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.toggle-btn ion-icon {
  font-size: 20px;
}

.filter-toggle-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.45);
  transition: all var(--transition-speed);
  font-size: 20px;
}
.filter-toggle-btn:hover {
  background: rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.7);
}
.filter-toggle-btn.active {
  color: var(--active-color, #6c63ff);
  background: rgba(108, 99, 255, 0.1);
}
.filter-toggle-btn ion-icon {
  font-size: 20px;
}

/* Active filter chips */
.active-filter-chips {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
  padding-top: 8px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-family: var(--font);
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition-speed);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.18);
  line-height: 1.3;
}
.chip:hover {
  opacity: 0.8;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}
.chip ion-icon {
  font-size: 15px;
  opacity: 0.8;
}

.clear-all-btn {
  background: none;
  border: 1px solid var(--clear-border);
  font-size: 0.78rem;
  font-family: var(--font);
  font-weight: 500;
  cursor: pointer;
  padding: 4px 12px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: all var(--transition-speed);
}
.clear-all-btn ion-icon {
  font-size: 15px;
}
.clear-all-btn:hover {
  opacity: 0.75;
  background: rgba(0, 0, 0, 0.04);
}

/* ===========================================================
   MAIN LAYOUT
   =========================================================== */
.main-layout {
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

/* Filter Sidebar */
.filter-sidebar {
  width: var(--sidebar-width);
  flex-shrink: 0;
  border-right: 1px solid rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.filter-sidebar::-webkit-scrollbar {
  width: 4px;
}
.filter-sidebar::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 4px;
}
.filter-sidebar::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-header {
  padding: 20px 20px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
}
.sidebar-header h3 {
  margin: 0;
  font-family: var(--font);
  font-weight: 600;
  font-size: 0.95rem;
}

.sidebar-clear {
  background: none;
  border: 1px solid var(--clear-border);
  font-size: 0.82rem;
  font-family: var(--font);
  font-weight: 500;
  cursor: pointer;
  padding: 8px 20px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all var(--transition-speed);
  width: 100%;
  opacity: 1;
}
.sidebar-clear ion-icon {
  font-size: 17px;
}
.sidebar-clear:hover:not(.disabled) {
  opacity: 0.8;
  background: rgba(0, 0, 0, 0.04);
}
.sidebar-clear.disabled {
  opacity: 0.35;
  border-color: var(--clear-border-disabled, rgba(0, 0, 0, 0.15));
  cursor: default;
}

.sidebar-footer {
  flex-shrink: 0;
  border-top: 1px solid;
  padding: 16px 20px;
}

.sidebar-filters {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 8px 0;
}
.sidebar-filters::-webkit-scrollbar {
  width: 4px;
}
.sidebar-filters::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}
.sidebar-filters::-webkit-scrollbar-track {
  background: transparent;
}

.filter-section {
  padding: 12px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
}
.filter-section:last-child {
  border-bottom: none;
}

.sort-section {
  background: rgba(0, 0, 0, 0.02);
}

.sort-options {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.sort-option {
  padding: 5px 12px;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: transparent;
  font-size: 0.78rem;
  font-family: var(--font);
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition-speed);
}
.sort-option:hover {
  background: rgba(0, 0, 0, 0.04);
  border-color: rgba(0, 0, 0, 0.18);
}
.sort-option.active {
  background: var(--sort-active, #6c63ff);
  color: var(--sort-text, #fff) !important;
  border-color: var(--sort-active, #6c63ff);
}

.filter-title {
  margin: 0 0 10px;
  font-family: var(--font);
  font-weight: 600;
  font-size: 0.82rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: 0.8;
}

.filter-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 200px;
  overflow-y: auto;
}
.filter-list::-webkit-scrollbar {
  width: 3px;
}
.filter-list::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.12);
  border-radius: 3px;
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 8px;
  border-radius: 6px;
  cursor: pointer;
  transition: background var(--transition-speed);
  position: relative;
  -webkit-user-select: none;
          user-select: none;
}
.filter-item:hover {
  background: rgba(0, 0, 0, 0.03);
}
.filter-item input[type=checkbox] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.filter-item .checkmark {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 2px solid rgba(0, 0, 0, 0.2);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-speed);
  position: relative;
}
.filter-item .checkmark::after {
  content: "";
  width: 5px;
  height: 9px;
  border: 2px solid #fff;
  border-top: none;
  border-left: none;
  transform: rotate(45deg) scale(0);
  transition: transform var(--transition-speed);
  position: absolute;
  top: 1px;
}
.filter-item.checked .checkmark {
  background: var(--check-color, #6c63ff);
  border-color: var(--check-color, #6c63ff);
}
.filter-item.checked .checkmark::after {
  transform: rotate(45deg) scale(1);
}

.filter-label {
  font-size: 0.85rem;
  font-family: var(--font);
  font-weight: 400;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Content Area */
.content-area {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-bottom: max(env(safe-area-inset-bottom, 16px), 24px);
}
.content-area::-webkit-scrollbar {
  width: 6px;
}
.content-area::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.12);
  border-radius: 6px;
}
.content-area::-webkit-scrollbar-track {
  background: transparent;
}

/* ===========================================================
   LIST VIEW
   =========================================================== */
.list-view-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.list-viewport {
  flex: 1;
  width: 100%;
  overflow-x: hidden;
}
.list-viewport::-webkit-scrollbar {
  width: 6px;
}
.list-viewport::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.12);
  border-radius: 6px;
}
.list-viewport::-webkit-scrollbar-track {
  background: transparent;
}

.speaker-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 28px;
  min-height: var(--row-height);
  cursor: pointer;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
  transition: background var(--transition-speed), transform var(--transition-speed);
  will-change: transform;
  overflow: hidden;
  max-width: 100%;
}
.speaker-row:hover {
  background: var(--row-hover, rgba(0, 0, 0, 0.02));
  transform: translateX(3px);
}
.speaker-row:active {
  transform: translateX(1px);
}

.row-avatar {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.online-indicator {
  position: absolute;
  bottom: 1px;
  right: 1px;
  width: 13px;
  height: 13px;
  background: var(--online-color, #2ecc71);
  border-radius: 50%;
  border: 2.5px solid #fff;
  z-index: 2;
}

.row-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.row-name {
  font-weight: 600;
  font-size: 0.95rem;
  font-family: var(--font);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
}

.row-title {
  font-size: 0.82rem;
  font-family: var(--font);
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
  opacity: 0.8;
}

.row-company {
  font-size: 0.78rem;
  font-family: var(--font);
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 4px;
  opacity: 0.7;
  overflow: hidden;
  word-break: break-word;
}
.row-company ion-icon {
  font-size: 14px;
  flex-shrink: 0;
}

.row-arrow {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  opacity: 0.3;
  transition: opacity var(--transition-speed);
}
.speaker-row:hover .row-arrow {
  opacity: 0.6;
}
.row-arrow ion-icon {
  font-size: 18px;
}

/* ===========================================================
   GRID / CARD VIEW
   =========================================================== */
.grid-view-container {
  flex: 1;
  padding: 24px 28px 56px;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(var(--card-min-width), 1fr));
  gap: 20px;
}

.speaker-card {
  background: var(--card-bg, #fff);
  border-radius: 14px;
  overflow: hidden;
  cursor: pointer;
  transition: all var(--transition-speed);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.04);
  will-change: transform;
  display: flex;
  flex-direction: column;
}
.speaker-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px var(--card-shadow, rgba(0, 0, 0, 0.1));
}
.speaker-card:active {
  transform: translateY(-1px);
}

.card-avatar-section {
  padding: 28px 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.card-avatar {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
}

.card-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.card-online {
  position: absolute;
  bottom: 18px;
  right: calc(50% - 46px);
  width: 16px;
  height: 16px;
  background: var(--online-color, #2ecc71);
  border-radius: 50%;
  border: 3px solid #fff;
}

.card-body {
  padding: 16px 20px 20px;
  text-align: center;
  flex: 1;
  overflow: hidden;
  min-width: 0;
}

.card-name {
  font-weight: 600;
  font-size: 1rem;
  font-family: var(--font);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
  margin-bottom: 4px;
}

.card-title {
  font-size: 0.82rem;
  font-family: var(--font);
  font-weight: 400;
  opacity: 0.8;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
  margin-bottom: 8px;
}

.card-company {
  font-size: 0.78rem;
  font-family: var(--font);
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  opacity: 0.65;
  overflow: hidden;
  word-break: break-word;
}
.card-company ion-icon {
  font-size: 14px;
  flex-shrink: 0;
}

.card-footer {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  padding: 10px 16px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.view-profile-text {
  font-size: 0.78rem;
  font-family: var(--font);
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
  opacity: 0.8;
  transition: opacity 0.2s;
}
.view-profile-text ion-icon {
  font-size: 14px;
}

.speaker-card:hover .view-profile-text {
  opacity: 1;
}

/* ===========================================================
   PAGINATION CONTROLS
   =========================================================== */
.pagination-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 24px 0 8px;
}

.page-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 20px;
  border: 1px solid var(--btn-color, #6c63ff);
  background: transparent;
  color: var(--btn-color, #6c63ff);
  border-radius: 8px;
  font-family: var(--font);
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition-speed);
}
.page-btn:hover:not(.disabled) {
  background: var(--btn-color, #6c63ff);
  color: var(--pagination-text, #fff);
}
.page-btn.disabled {
  opacity: 0.35;
  cursor: not-allowed;
}
.page-btn ion-icon {
  font-size: 16px;
}

.page-info {
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: var(--font);
  font-size: 0.9rem;
  font-weight: 500;
}

.page-separator {
  opacity: 0.4;
}

.page-total {
  opacity: 0.6;
}

.loading-more {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 0;
}

/* ===========================================================
   GROUPS VIEW
   =========================================================== */
.groups-view {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.groups-header {
  padding: 12px 28px;
}
.groups-header ion-searchbar {
  --icon-color: rgba(0, 0, 0, 0.4);
  font-family: var(--font);
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
}

.groups-grid {
  flex: 1;
  overflow-y: auto;
  padding: 20px 28px 28px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
}
.groups-grid::-webkit-scrollbar {
  width: 6px;
}
.groups-grid::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.12);
  border-radius: 6px;
}

.group-card {
  border-radius: 14px;
  overflow: hidden;
  cursor: pointer;
  transition: all var(--transition-speed);
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.04);
  will-change: transform;
}
.group-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.group-card-inner {
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
}

.group-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--group-bg, #6c63ff);
  display: flex;
  align-items: center;
  justify-content: center;
}
.group-icon ion-icon {
  font-size: 24px;
  color: var(--group-text, #fff);
}

.group-name {
  font-family: var(--font);
  font-weight: 600;
  font-size: 0.95rem;
  color: var(--group-text, inherit);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.group-count {
  font-family: var(--font);
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--group-text, inherit);
  opacity: 0.7;
  padding: 3px 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.2);
}

/* ===========================================================
   LOADING / SKELETON STATES
   =========================================================== */
.loading-state {
  padding: 20px 28px;
}

.skeleton-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.skeleton-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
}

.skeleton-avatar {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  flex-shrink: 0;
}

.skeleton-texts {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.skeleton-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(var(--card-min-width), 1fr));
  gap: 20px;
}

.skeleton-card {
  background: var(--card-bg, #fff);
  border-radius: 14px;
  padding: 28px 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.skeleton-card-avatar {
  width: 88px;
  height: 88px;
  border-radius: 50%;
}

.skeleton-group-card {
  background: #fff;
  border-radius: 14px;
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

/* ===========================================================
   EMPTY STATE
   =========================================================== */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 28px;
  text-align: center;
}

.empty-icon {
  font-size: 4rem;
  opacity: 0.3;
  margin-bottom: 20px;
}
.empty-icon ion-icon {
  font-size: 4rem;
}

.empty-texts {
  max-width: 360px;
}
.empty-texts h3 {
  font-family: var(--font);
  font-weight: 600;
  font-size: 1.1rem;
  margin: 0 0 8px;
}
.empty-texts p {
  font-family: var(--font);
  font-weight: 400;
  font-size: 0.88rem;
  line-height: 1.5;
  margin: 0 0 16px;
  opacity: 0.75;
}

/* ===========================================================
   RESPONSIVE
   =========================================================== */
@media screen and (max-width: 1024px) {
  .filter-sidebar {
    width: 240px;
  }
  .card-grid {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  }
}
@media screen and (max-width: 820px) {
  .search-toolbar {
    padding: 12px 16px;
  }
  .speaker-row {
    padding: 12px 16px;
  }
  .grid-view-container {
    padding: 16px;
  }
  .filter-sidebar {
    width: 220px;
  }
}
@media screen and (max-width: 400px) {
  .search-toolbar {
    padding: 10px 12px;
  }
  .speaker-row {
    padding: 10px 12px;
    gap: 10px;
  }
  .grid-view-container {
    padding: 12px;
  }
  .card-body {
    padding: 12px 14px 16px;
  }
  .row-arrow {
    display: none;
  }
}
/* Hide scrollbar utility */
.hide_scrollbar {
  scrollbar-width: thin;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/speakers/speakers.page.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,wBAAA;AACJ;;AAEA;EACI,6BAAA;EACA,gBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AACJ;;AAEA;EACI,oBAAA;EACA,iBAAA;EACA,yCAAA;EACA,WAAA;AACJ;;AAEA;EACI,wBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;AACJ;;AAEA;;gEAAA;AAGA;EACI,4CAAA;EACA,kBAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AACJ;;AAEA;EACI,OAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,kFAAA;AACJ;AACI;EACI,gBAAA;EACA,kDAAA;AACR;;AAGA;EACI,eAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAAJ;;AAGA;EACI,YAAA;EACA,uBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,cAAA;AAAJ;AAEI;EACI,aAAA;EACA,gBAAA;AAAR;AAGI;EACI,+BAAA;EACA,YAAA;AADR;;AAKA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAFJ;;AAKA;EACI,aAAA;EACA,+BAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;AAFJ;;AAKA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;EACA,uCAAA;EACA,eAAA;AAFJ;AAII;EACI,yBAAA;EACA,+BAAA;AAFR;AAKI;EACI,gBAAA;EACA,mCAAA;EACA,wCAAA;AAHR;AAMI;EACI,eAAA;AAJR;;AAQA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;EACA,uCAAA;EACA,eAAA;AALJ;AAOI;EACI,+BAAA;EACA,yBAAA;AALR;AAQI;EACI,mCAAA;EACA,mCAAA;AANR;AASI;EACI,eAAA;AAPR;;AAWA,wBAAA;AACA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,yCAAA;AARJ;;AAWA;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,uCAAA;EACA,yCAAA;EACA,2CAAA;EACA,gBAAA;AARJ;AAUI;EACI,YAAA;EACA,yCAAA;AARR;AAWI;EACI,eAAA;EACA,YAAA;AATR;;AAaA;EACI,gBAAA;EACA,qCAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,uCAAA;AAVJ;AAYI;EACI,eAAA;AAVR;AAaI;EACI,aAAA;EACA,+BAAA;AAXR;;AAeA;;gEAAA;AAGA;EACI,aAAA;EACA,OAAA;EACA,aAAA;EACA,gBAAA;AAZJ;;AAeA,mBAAA;AACA;EACI,2BAAA;EACA,cAAA;EACA,2CAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAZJ;AAcI;EACI,UAAA;AAZR;AAeI;EACI,+BAAA;EACA,kBAAA;AAbR;AAgBI;EACI,uBAAA;AAdR;;AAkBA;EACI,uBAAA;EACA,4CAAA;EACA,cAAA;AAfJ;AAiBI;EACI,SAAA;EACA,wBAAA;EACA,gBAAA;EACA,kBAAA;AAfR;;AAmBA;EACI,gBAAA;EACA,qCAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,uCAAA;EACA,WAAA;EACA,UAAA;AAhBJ;AAkBI;EACI,eAAA;AAhBR;AAmBI;EACI,YAAA;EACA,+BAAA;AAjBR;AAoBI;EACI,aAAA;EACA,+DAAA;EACA,eAAA;AAlBR;;AAsBA;EACI,cAAA;EACA,qBAAA;EACA,kBAAA;AAnBJ;;AAsBA;EACI,OAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAnBJ;AAqBI;EACI,UAAA;AAnBR;AAsBI;EACI,+BAAA;EACA,kBAAA;AApBR;AAuBI;EACI,uBAAA;AArBR;;AAyBA;EACI,kBAAA;EACA,4CAAA;AAtBJ;AAwBI;EACI,mBAAA;AAtBR;;AA0BA;EACI,+BAAA;AAvBJ;;AA0BA;EACI,aAAA;EACA,eAAA;EACA,QAAA;AAvBJ;;AA0BA;EACI,iBAAA;EACA,kBAAA;EACA,oCAAA;EACA,uBAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,uCAAA;AAvBJ;AAyBI;EACI,+BAAA;EACA,iCAAA;AAvBR;AA0BI;EACI,uCAAA;EACA,wCAAA;EACA,yCAAA;AAxBR;;AA4BA;EACI,gBAAA;EACA,wBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;AAzBJ;;AA4BA;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;AAzBJ;AA2BI;EACI,UAAA;AAzBR;AA4BI;EACI,+BAAA;EACA,kBAAA;AA1BR;;AA8BA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,8CAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;AA3BJ;AA6BI;EACI,+BAAA;AA3BR;AA8BI;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;AA5BR;AA+BI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uCAAA;EACA,kBAAA;AA7BR;AA+BQ;EACI,WAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iCAAA;EACA,6CAAA;EACA,kBAAA;EACA,QAAA;AA7BZ;AAiCI;EACI,uCAAA;EACA,yCAAA;AA/BR;AAiCQ;EACI,iCAAA;AA/BZ;;AAoCA;EACI,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAjCJ;;AAoCA,iBAAA;AACA;EACI,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,4DAAA;AAjCJ;AAmCI;EACI,UAAA;AAjCR;AAoCI;EACI,+BAAA;EACA,kBAAA;AAlCR;AAqCI;EACI,uBAAA;AAnCR;;AAuCA;;gEAAA;AAGA;EACI,OAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AApCJ;;AAuCA;EACI,OAAA;EACA,WAAA;EACA,kBAAA;AApCJ;AAsCI;EACI,UAAA;AApCR;AAuCI;EACI,+BAAA;EACA,kBAAA;AArCR;AAwCI;EACI,uBAAA;AAtCR;;AA0CA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,4CAAA;EACA,iFAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;AAvCJ;AAyCI;EACI,iDAAA;EACA,0BAAA;AAvCR;AA0CI;EACI,0BAAA;AAxCR;;AA4CA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAzCJ;;AA4CA;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAzCJ;;AA4CA;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,wCAAA;EACA,kBAAA;EACA,wBAAA;EACA,UAAA;AAzCJ;;AA4CA;EACI,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAzCJ;;AA4CA;EACI,gBAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,sBAAA;AAzCJ;;AA4CA;EACI,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,sBAAA;EACA,YAAA;AAzCJ;;AA4CA;EACI,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;AAzCJ;AA2CI;EACI,eAAA;EACA,cAAA;AAzCR;;AA6CA;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,2CAAA;AA1CJ;AA4CI;EACI,YAAA;AA1CR;AA6CI;EACI,eAAA;AA3CR;;AA+CA;;gEAAA;AAGA;EACI,OAAA;EACA,uBAAA;AA5CJ;;AA+CA;EACI,aAAA;EACA,4EAAA;EACA,SAAA;AA5CJ;;AA+CA;EACI,gCAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,uCAAA;EACA,yCAAA;EACA,qCAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;AA5CJ;AA8CI;EACI,2BAAA;EACA,6DAAA;AA5CR;AA+CI;EACI,2BAAA;AA7CR;;AAiDA;EACI,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AA9CJ;;AAiDA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AA9CJ;;AAiDA;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AA9CJ;;AAiDA;EACI,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,wCAAA;EACA,kBAAA;EACA,sBAAA;AA9CJ;;AAiDA;EACI,uBAAA;EACA,kBAAA;EACA,OAAA;EACA,gBAAA;EACA,YAAA;AA9CJ;;AAiDA;EACI,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,sBAAA;EACA,kBAAA;AA9CJ;;AAiDA;EACI,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,sBAAA;EACA,kBAAA;AA9CJ;;AAiDA;EACI,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AA9CJ;AAgDI;EACI,eAAA;EACA,cAAA;AA9CR;;AAkDA;EACI,yCAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA/CJ;;AAkDA;EACI,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,wBAAA;AA/CJ;AAiDI;EACI,eAAA;AA/CR;;AAmDA;EACI,UAAA;AAhDJ;;AAmDA;;gEAAA;AAGA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAhDJ;;AAmDA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,2CAAA;EACA,uBAAA;EACA,gCAAA;EACA,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,uCAAA;AAhDJ;AAkDI;EACI,qCAAA;EACA,mCAAA;AAhDR;AAmDI;EACI,aAAA;EACA,mBAAA;AAjDR;AAoDI;EACI,eAAA;AAlDR;;AAsDA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,wBAAA;EACA,iBAAA;EACA,gBAAA;AAnDJ;;AAsDA;EACI,YAAA;AAnDJ;;AAsDA;EACI,YAAA;AAnDJ;;AAsDA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAnDJ;;AAsDA;;gEAAA;AAGA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;AAnDJ;;AAsDA;EACI,kBAAA;AAnDJ;AAqDI;EACI,gCAAA;EACA,wBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AAnDR;;AAuDA;EACI,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,4DAAA;EACA,SAAA;AApDJ;AAsDI;EACI,UAAA;AApDR;AAuDI;EACI,+BAAA;EACA,kBAAA;AArDR;;AAyDA;EACI,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,uCAAA;EACA,gBAAA;EACA,yCAAA;EACA,qCAAA;EACA,sBAAA;AAtDJ;AAwDI;EACI,2BAAA;EACA,yCAAA;AAtDR;;AA0DA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAvDJ;;AA0DA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAvDJ;AAyDI;EACI,eAAA;EACA,8BAAA;AAvDR;;AA2DA;EACI,wBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;AAxDJ;;AA2DA;EACI,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iCAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,oCAAA;AAxDJ;;AA2DA;;gEAAA;AAGA;EACI,kBAAA;AAxDJ;;AA2DA;EACI,aAAA;EACA,sBAAA;EACA,MAAA;AAxDJ;;AA2DA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,4CAAA;AAxDJ;;AA2DA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAxDJ;;AA2DA;EACI,OAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAxDJ;;AA2DA;EACI,aAAA;EACA,4EAAA;EACA,SAAA;AAxDJ;;AA2DA;EACI,gCAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAxDJ;;AA2DA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAxDJ;;AA2DA;EACI,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AAxDJ;;AA2DA;;gEAAA;AAGA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AAxDJ;;AA2DA;EACI,eAAA;EACA,YAAA;EACA,mBAAA;AAxDJ;AA0DI;EACI,eAAA;AAxDR;;AA4DA;EACI,gBAAA;AAzDJ;AA2DI;EACI,wBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAzDR;AA4DI;EACI,wBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;AA1DR;;AA+DA;;gEAAA;AAGA;EACI;IACI,YAAA;EA5DN;EA+DE;IACI,4DAAA;EA7DN;AACF;AAgEA;EACI;IACI,kBAAA;EA9DN;EAiEE;IACI,kBAAA;EA/DN;EAkEE;IACI,aAAA;EAhEN;EAmEE;IACI,YAAA;EAjEN;AACF;AAoEA;EACI;IACI,kBAAA;EAlEN;EAqEE;IACI,kBAAA;IACA,SAAA;EAnEN;EAsEE;IACI,aAAA;EApEN;EAuEE;IACI,uBAAA;EArEN;EAwEE;IACI,aAAA;EAtEN;AACF;AAyEA,2BAAA;AACA;EACI,qBAAA;AAvEJ","sourcesContent":[":host {\n    --sidebar-width: 280px;\n    --row-height: 80px;\n    --card-min-width: 260px;\n    --transition-speed: 0.2s;\n}\n\nion-content {\n    --background: var(--bg-color);\n    --padding-top: 0;\n    overflow-x: hidden;\n}\n\n.content-wrapper {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    overflow: hidden;\n}\n\nion-toolbar {\n    --border-style: none;\n    --border-width: 0;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n    z-index: 20;\n}\n\nion-title p {\n    font-family: var(--font);\n    font-weight: 600;\n    font-size: 1.1rem;\n    margin: 0;\n}\n\n/* ===========================================================\n   SEARCH TOOLBAR\n   =========================================================== */\n.search-toolbar {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n    padding: 12px 28px;\n    position: sticky;\n    top: 0;\n    z-index: 15;\n}\n\n.search-toolbar-row {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.search-wrapper {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    align-items: center;\n    background: rgba(0, 0, 0, 0.04);\n    border-radius: 10px;\n    padding: 0 16px;\n    height: 44px;\n    transition: box-shadow var(--transition-speed), background var(--transition-speed);\n\n    &:focus-within {\n        background: #fff;\n        box-shadow: 0 0 0 2px var(--active-color, #6c63ff);\n    }\n}\n\n.search-icon {\n    font-size: 20px;\n    opacity: 0.5;\n    margin-right: 12px;\n    flex-shrink: 0;\n}\n\n.search-input {\n    border: none;\n    background: transparent;\n    outline: none;\n    width: 100%;\n    min-width: 0;\n    height: 100%;\n    font-size: 0.95rem;\n    font-family: var(--font);\n    color: inherit;\n\n    &:focus {\n        outline: none;\n        box-shadow: none;\n    }\n\n    &::placeholder {\n        color: var(--placeholder-color);\n        opacity: 0.6;\n    }\n}\n\n.toolbar-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n}\n\n.view-toggle {\n    display: flex;\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 8px;\n    padding: 3px;\n    gap: 2px;\n}\n\n.toggle-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 34px;\n    border: none;\n    background: transparent;\n    border-radius: 6px;\n    cursor: pointer;\n    color: rgba(0, 0, 0, 0.45);\n    transition: all var(--transition-speed);\n    font-size: 20px;\n\n    &:hover {\n        color: rgba(0, 0, 0, 0.7);\n        background: rgba(0, 0, 0, 0.04);\n    }\n\n    &.active {\n        background: #fff;\n        color: var(--active-color, #6c63ff);\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    }\n\n    ion-icon {\n        font-size: 20px;\n    }\n}\n\n.filter-toggle-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 38px;\n    height: 38px;\n    border: none;\n    background: transparent;\n    border-radius: 8px;\n    cursor: pointer;\n    color: rgba(0, 0, 0, 0.45);\n    transition: all var(--transition-speed);\n    font-size: 20px;\n\n    &:hover {\n        background: rgba(0, 0, 0, 0.05);\n        color: rgba(0, 0, 0, 0.7);\n    }\n\n    &.active {\n        color: var(--active-color, #6c63ff);\n        background: rgba(108, 99, 255, 0.1);\n    }\n\n    ion-icon {\n        font-size: 20px;\n    }\n}\n\n/* Active filter chips */\n.active-filter-chips {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-top: 12px;\n    padding-top: 8px;\n    border-top: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 5px 12px;\n    border-radius: 20px;\n    font-size: 0.8rem;\n    font-family: var(--font);\n    font-weight: 500;\n    cursor: pointer;\n    transition: all var(--transition-speed);\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n    border: 1px solid rgba(255, 255, 255, 0.18);\n    line-height: 1.3;\n\n    &:hover {\n        opacity: 0.8;\n        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);\n    }\n\n    ion-icon {\n        font-size: 15px;\n        opacity: 0.8;\n    }\n}\n\n.clear-all-btn {\n    background: none;\n    border: 1px solid var(--clear-border);\n    font-size: 0.78rem;\n    font-family: var(--font);\n    font-weight: 500;\n    cursor: pointer;\n    padding: 4px 12px;\n    border-radius: 20px;\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    transition: all var(--transition-speed);\n\n    ion-icon {\n        font-size: 15px;\n    }\n\n    &:hover {\n        opacity: 0.75;\n        background: rgba(0, 0, 0, 0.04);\n    }\n}\n\n/* ===========================================================\n   MAIN LAYOUT\n   =========================================================== */\n.main-layout {\n    display: flex;\n    flex: 1;\n    min-height: 0;\n    overflow: hidden;\n}\n\n/* Filter Sidebar */\n.filter-sidebar {\n    width: var(--sidebar-width);\n    flex-shrink: 0;\n    border-right: 1px solid rgba(0, 0, 0, 0.06);\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n\n    &::-webkit-scrollbar {\n        width: 4px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: rgba(0, 0, 0, 0.15);\n        border-radius: 4px;\n    }\n\n    &::-webkit-scrollbar-track {\n        background: transparent;\n    }\n}\n\n.sidebar-header {\n    padding: 20px 20px 16px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n    flex-shrink: 0;\n\n    h3 {\n        margin: 0;\n        font-family: var(--font);\n        font-weight: 600;\n        font-size: 0.95rem;\n    }\n}\n\n.sidebar-clear {\n    background: none;\n    border: 1px solid var(--clear-border);\n    font-size: 0.82rem;\n    font-family: var(--font);\n    font-weight: 500;\n    cursor: pointer;\n    padding: 8px 20px;\n    border-radius: 8px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    transition: all var(--transition-speed);\n    width: 100%;\n    opacity: 1;\n\n    ion-icon {\n        font-size: 17px;\n    }\n\n    &:hover:not(.disabled) {\n        opacity: 0.8;\n        background: rgba(0, 0, 0, 0.04);\n    }\n\n    &.disabled {\n        opacity: 0.35;\n        border-color: var(--clear-border-disabled, rgba(0, 0, 0, 0.15));\n        cursor: default;\n    }\n}\n\n.sidebar-footer {\n    flex-shrink: 0;\n    border-top: 1px solid;\n    padding: 16px 20px;\n}\n\n.sidebar-filters {\n    flex: 1;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 8px 0;\n\n    &::-webkit-scrollbar {\n        width: 4px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: rgba(0, 0, 0, 0.12);\n        border-radius: 4px;\n    }\n\n    &::-webkit-scrollbar-track {\n        background: transparent;\n    }\n}\n\n.filter-section {\n    padding: 12px 20px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.04);\n\n    &:last-child {\n        border-bottom: none;\n    }\n}\n\n.sort-section {\n    background: rgba(0, 0, 0, 0.02);\n}\n\n.sort-options {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n}\n\n.sort-option {\n    padding: 5px 12px;\n    border-radius: 6px;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    background: transparent;\n    font-size: 0.78rem;\n    font-family: var(--font);\n    font-weight: 500;\n    cursor: pointer;\n    transition: all var(--transition-speed);\n\n    &:hover {\n        background: rgba(0, 0, 0, 0.04);\n        border-color: rgba(0, 0, 0, 0.18);\n    }\n\n    &.active {\n        background: var(--sort-active, #6c63ff);\n        color: var(--sort-text, #fff) !important;\n        border-color: var(--sort-active, #6c63ff);\n    }\n}\n\n.filter-title {\n    margin: 0 0 10px;\n    font-family: var(--font);\n    font-weight: 600;\n    font-size: 0.82rem;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    opacity: 0.8;\n}\n\n.filter-list {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    max-height: 200px;\n    overflow-y: auto;\n\n    &::-webkit-scrollbar {\n        width: 3px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: rgba(0, 0, 0, 0.12);\n        border-radius: 3px;\n    }\n}\n\n.filter-item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 6px 8px;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: background var(--transition-speed);\n    position: relative;\n    user-select: none;\n\n    &:hover {\n        background: rgba(0, 0, 0, 0.03);\n    }\n\n    input[type=\"checkbox\"] {\n        position: absolute;\n        opacity: 0;\n        width: 0;\n        height: 0;\n    }\n\n    .checkmark {\n        width: 18px;\n        height: 18px;\n        border-radius: 4px;\n        border: 2px solid rgba(0, 0, 0, 0.2);\n        flex-shrink: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        transition: all var(--transition-speed);\n        position: relative;\n\n        &::after {\n            content: '';\n            width: 5px;\n            height: 9px;\n            border: 2px solid #fff;\n            border-top: none;\n            border-left: none;\n            transform: rotate(45deg) scale(0);\n            transition: transform var(--transition-speed);\n            position: absolute;\n            top: 1px;\n        }\n    }\n\n    &.checked .checkmark {\n        background: var(--check-color, #6c63ff);\n        border-color: var(--check-color, #6c63ff);\n\n        &::after {\n            transform: rotate(45deg) scale(1);\n        }\n    }\n}\n\n.filter-label {\n    font-size: 0.85rem;\n    font-family: var(--font);\n    font-weight: 400;\n    flex: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n/* Content Area */\n.content-area {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n    padding-bottom: max(env(safe-area-inset-bottom, 16px), 24px);\n\n    &::-webkit-scrollbar {\n        width: 6px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: rgba(0, 0, 0, 0.12);\n        border-radius: 6px;\n    }\n\n    &::-webkit-scrollbar-track {\n        background: transparent;\n    }\n}\n\n/* ===========================================================\n   LIST VIEW\n   =========================================================== */\n.list-view-container {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.list-viewport {\n    flex: 1;\n    width: 100%;\n    overflow-x: hidden;\n\n    &::-webkit-scrollbar {\n        width: 6px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: rgba(0, 0, 0, 0.12);\n        border-radius: 6px;\n    }\n\n    &::-webkit-scrollbar-track {\n        background: transparent;\n    }\n}\n\n.speaker-row {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    padding: 12px 28px;\n    min-height: var(--row-height);\n    cursor: pointer;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.04);\n    transition: background var(--transition-speed), transform var(--transition-speed);\n    will-change: transform;\n    overflow: hidden;\n    max-width: 100%;\n\n    &:hover {\n        background: var(--row-hover, rgba(0, 0, 0, 0.02));\n        transform: translateX(3px);\n    }\n\n    &:active {\n        transform: translateX(1px);\n    }\n}\n\n.row-avatar {\n    width: 52px;\n    height: 52px;\n    border-radius: 50%;\n    flex-shrink: 0;\n    position: relative;\n    overflow: hidden;\n}\n\n.avatar-img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 50%;\n}\n\n.online-indicator {\n    position: absolute;\n    bottom: 1px;\n    right: 1px;\n    width: 13px;\n    height: 13px;\n    background: var(--online-color, #2ecc71);\n    border-radius: 50%;\n    border: 2.5px solid #fff;\n    z-index: 2;\n}\n\n.row-info {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n}\n\n.row-name {\n    font-weight: 600;\n    font-size: 0.95rem;\n    font-family: var(--font);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    word-break: break-word;\n}\n\n.row-title {\n    font-size: 0.82rem;\n    font-family: var(--font);\n    font-weight: 400;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    word-break: break-word;\n    opacity: 0.8;\n}\n\n.row-company {\n    font-size: 0.78rem;\n    font-family: var(--font);\n    font-weight: 400;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    opacity: 0.7;\n    overflow: hidden;\n    word-break: break-word;\n\n    ion-icon {\n        font-size: 14px;\n        flex-shrink: 0;\n    }\n}\n\n.row-arrow {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    opacity: 0.3;\n    transition: opacity var(--transition-speed);\n\n    .speaker-row:hover & {\n        opacity: 0.6;\n    }\n\n    ion-icon {\n        font-size: 18px;\n    }\n}\n\n/* ===========================================================\n   GRID / CARD VIEW\n   =========================================================== */\n.grid-view-container {\n    flex: 1;\n    padding: 24px 28px 56px;\n}\n\n.card-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(var(--card-min-width), 1fr));\n    gap: 20px;\n}\n\n.speaker-card {\n    background: var(--card-bg, #fff);\n    border-radius: 14px;\n    overflow: hidden;\n    cursor: pointer;\n    transition: all var(--transition-speed);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n    border: 1px solid rgba(0, 0, 0, 0.04);\n    will-change: transform;\n    display: flex;\n    flex-direction: column;\n\n    &:hover {\n        transform: translateY(-4px);\n        box-shadow: 0 8px 24px var(--card-shadow, rgba(0, 0, 0, 0.1));\n    }\n\n    &:active {\n        transform: translateY(-1px);\n    }\n}\n\n.card-avatar-section {\n    padding: 28px 20px 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    position: relative;\n}\n\n.card-avatar {\n    width: 88px;\n    height: 88px;\n    border-radius: 50%;\n    overflow: hidden;\n    position: relative;\n}\n\n.card-avatar-img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 50%;\n}\n\n.card-online {\n    position: absolute;\n    bottom: 18px;\n    right: calc(50% - 46px);\n    width: 16px;\n    height: 16px;\n    background: var(--online-color, #2ecc71);\n    border-radius: 50%;\n    border: 3px solid #fff;\n}\n\n.card-body {\n    padding: 16px 20px 20px;\n    text-align: center;\n    flex: 1;\n    overflow: hidden;\n    min-width: 0;\n}\n\n.card-name {\n    font-weight: 600;\n    font-size: 1rem;\n    font-family: var(--font);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    word-break: break-word;\n    margin-bottom: 4px;\n}\n\n.card-title {\n    font-size: 0.82rem;\n    font-family: var(--font);\n    font-weight: 400;\n    opacity: 0.8;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    word-break: break-word;\n    margin-bottom: 8px;\n}\n\n.card-company {\n    font-size: 0.78rem;\n    font-family: var(--font);\n    font-weight: 400;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    opacity: 0.65;\n    overflow: hidden;\n    word-break: break-word;\n\n    ion-icon {\n        font-size: 14px;\n        flex-shrink: 0;\n    }\n}\n\n.card-footer {\n    border-top: 1px solid rgba(0, 0, 0, 0.06);\n    padding: 10px 16px 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.view-profile-text {\n    font-size: 0.78rem;\n    font-family: var(--font);\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    opacity: 0.8;\n    transition: opacity 0.2s;\n\n    ion-icon {\n        font-size: 14px;\n    }\n}\n\n.speaker-card:hover .view-profile-text {\n    opacity: 1;\n}\n\n/* ===========================================================\n   PAGINATION CONTROLS\n   =========================================================== */\n.pagination-controls {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 16px;\n    padding: 24px 0 8px;\n}\n\n.page-btn {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 8px 20px;\n    border: 1px solid var(--btn-color, #6c63ff);\n    background: transparent;\n    color: var(--btn-color, #6c63ff);\n    border-radius: 8px;\n    font-family: var(--font);\n    font-size: 0.85rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all var(--transition-speed);\n\n    &:hover:not(.disabled) {\n        background: var(--btn-color, #6c63ff);\n        color: var(--pagination-text, #fff);\n    }\n\n    &.disabled {\n        opacity: 0.35;\n        cursor: not-allowed;\n    }\n\n    ion-icon {\n        font-size: 16px;\n    }\n}\n\n.page-info {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-family: var(--font);\n    font-size: 0.9rem;\n    font-weight: 500;\n}\n\n.page-separator {\n    opacity: 0.4;\n}\n\n.page-total {\n    opacity: 0.6;\n}\n\n.loading-more {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 16px 0;\n}\n\n/* ===========================================================\n   GROUPS VIEW\n   =========================================================== */\n.groups-view {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.groups-header {\n    padding: 12px 28px;\n\n    ion-searchbar {\n        --icon-color: rgba(0, 0, 0, 0.4);\n        font-family: var(--font);\n        width: 100%;\n        max-width: 400px;\n        margin: 0 auto;\n    }\n}\n\n.groups-grid {\n    flex: 1;\n    overflow-y: auto;\n    padding: 20px 28px 28px;\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 16px;\n\n    &::-webkit-scrollbar {\n        width: 6px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: rgba(0, 0, 0, 0.12);\n        border-radius: 6px;\n    }\n}\n\n.group-card {\n    border-radius: 14px;\n    overflow: hidden;\n    cursor: pointer;\n    transition: all var(--transition-speed);\n    background: #fff;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n    border: 1px solid rgba(0, 0, 0, 0.04);\n    will-change: transform;\n\n    &:hover {\n        transform: translateY(-3px);\n        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\n    }\n}\n\n.group-card-inner {\n    padding: 24px 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n    text-align: center;\n}\n\n.group-icon {\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    background: var(--group-bg, #6c63ff);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    ion-icon {\n        font-size: 24px;\n        color: var(--group-text, #fff);\n    }\n}\n\n.group-name {\n    font-family: var(--font);\n    font-weight: 600;\n    font-size: 0.95rem;\n    color: var(--group-text, inherit);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n}\n\n.group-count {\n    font-family: var(--font);\n    font-size: 0.8rem;\n    font-weight: 500;\n    color: var(--group-text, inherit);\n    opacity: 0.7;\n    padding: 3px 12px;\n    border-radius: 12px;\n    background: rgba(255, 255, 255, 0.2);\n}\n\n/* ===========================================================\n   LOADING / SKELETON STATES\n   =========================================================== */\n.loading-state {\n    padding: 20px 28px;\n}\n\n.skeleton-list {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n}\n\n.skeleton-row {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    padding: 16px 0;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.04);\n}\n\n.skeleton-avatar {\n    width: 52px;\n    height: 52px;\n    border-radius: 50%;\n    flex-shrink: 0;\n}\n\n.skeleton-texts {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.skeleton-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(var(--card-min-width), 1fr));\n    gap: 20px;\n}\n\n.skeleton-card {\n    background: var(--card-bg, #fff);\n    border-radius: 14px;\n    padding: 28px 20px 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.skeleton-card-avatar {\n    width: 88px;\n    height: 88px;\n    border-radius: 50%;\n}\n\n.skeleton-group-card {\n    background: #fff;\n    border-radius: 14px;\n    padding: 24px 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n}\n\n/* ===========================================================\n   EMPTY STATE\n   =========================================================== */\n.empty-state {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 60px 28px;\n    text-align: center;\n}\n\n.empty-icon {\n    font-size: 4rem;\n    opacity: 0.3;\n    margin-bottom: 20px;\n\n    ion-icon {\n        font-size: 4rem;\n    }\n}\n\n.empty-texts {\n    max-width: 360px;\n\n    h3 {\n        font-family: var(--font);\n        font-weight: 600;\n        font-size: 1.1rem;\n        margin: 0 0 8px;\n    }\n\n    p {\n        font-family: var(--font);\n        font-weight: 400;\n        font-size: 0.88rem;\n        line-height: 1.5;\n        margin: 0 0 16px;\n        opacity: 0.75;\n    }\n}\n\n\n/* ===========================================================\n   RESPONSIVE\n   =========================================================== */\n@media screen and (max-width: 1024px) {\n    .filter-sidebar {\n        width: 240px;\n    }\n\n    .card-grid {\n        grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n    }\n}\n\n@media screen and (max-width: 820px) {\n    .search-toolbar {\n        padding: 12px 16px;\n    }\n\n    .speaker-row {\n        padding: 12px 16px;\n    }\n\n    .grid-view-container {\n        padding: 16px;\n    }\n\n    .filter-sidebar {\n        width: 220px;\n    }\n}\n\n@media screen and (max-width: 400px) {\n    .search-toolbar {\n        padding: 10px 12px;\n    }\n\n    .speaker-row {\n        padding: 10px 12px;\n        gap: 10px;\n    }\n\n    .grid-view-container {\n        padding: 12px;\n    }\n\n    .card-body {\n        padding: 12px 14px 16px;\n    }\n\n    .row-arrow {\n        display: none;\n    }\n}\n\n/* Hide scrollbar utility */\n.hide_scrollbar {\n    scrollbar-width: thin;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
